import { c as _c } from "react-compiler-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardWrapper, CardSection } from 'foundations-components/transitional/components/Card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PublicSenderNotes = t0 => {
  const $ = _c(11);
  const {
    notes
  } = t0;
  const {
    senderName,
    senderEmail,
    message
  } = notes;
  let t1;
  if ($[0] !== senderName) {
    t1 = /*#__PURE__*/_jsx(Text, {
      typography: "heading-200",
      marginBlockEnd: "200",
      children: senderName ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "external-sharing-components.senderNotes.heading",
        options: {
          senderName
        }
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "external-sharing-components.senderNotes.headingFallback"
      })
    });
    $[0] = senderName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== message) {
    t2 = /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      marginBlockEnd: "300",
      children: message
    });
    $[2] = message;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== senderEmail || $[5] !== senderName) {
    t3 = senderEmail && /*#__PURE__*/_jsx(Flex, {
      children: /*#__PURE__*/_jsx(Button, {
        use: "secondary",
        href: `mailto:${senderEmail}`,
        external: true,
        hideExternalLinkIcon: true,
        size: "small",
        children: senderName ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "external-sharing-components.senderNotes.emailButton",
          options: {
            senderName
          }
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "external-sharing-components.senderNotes.emailButtonFallback"
        })
      })
    });
    $[4] = senderEmail;
    $[5] = senderName;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = /*#__PURE__*/_jsx(CardWrapper, {
      children: /*#__PURE__*/_jsxs(CardSection, {
        children: [t1, t2, t3]
      })
    });
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};